import { render, staticRenderFns } from "./WillTrustees.vue?vue&type=template&id=36cadf29"
import script from "./WillTrustees.vue?vue&type=script&lang=js"
export * from "./WillTrustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports